import { TSection } from '../../repositories/chats/entities/all_from_section_desktop_request/PublicV1ChatsBulkOperationsMoveAllFromSectionToArchiveDesktopRequestSchema';
import {
  fetchChatsBulkOperationsMoveAllFromSectionToArchiveDesktop,
  TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse,
} from '../../repositories/chats/v1/chats/bulk-operations/move-all-from-section-to-archive-desktop';
import { showAlert } from '../../slices/alertSlice';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';
import { toggleChatListPending } from '../chatList/actions';

const DEFAULT_ERROR_MESSAGE = 'Не удалось перенести в архив все чаты';

/**
 * Перенести в архив все чаты
 * @param {ESection} section раздел в котором нужно удалить сообщения
 */
export const archiveAllChats =
  (section: TSection): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    const { httpApi, logger } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsBulkOperationsMoveAllFromSectionToArchiveDesktopResponse =
        await fetchChatsBulkOperationsMoveAllFromSectionToArchiveDesktop({
          httpApi,
          parameters: {
            section,
          },
          config: { requestConfig: { withCredentials: true } },
        });

      if (statusCode !== 200) {
        throw getResponseError({
          domain: EExceptionDomain.Chat,
          response,
          defaultMessage: DEFAULT_ERROR_MESSAGE,
          statusCode,
        });
      }
    } catch (ex) {
      const exception = getGenericLikeError({
        error: ex,
        domain: EExceptionDomain.Chat,
        message: DEFAULT_ERROR_MESSAGE,
      });

      logger.error(exception, {
        microserviceName: 'chats',
        pathApi: '/v1/chats/bulk-operations/move-all-from-section-to-archive-desktop/',
        parameters: JSON.stringify({ section }),
      });

      dispatch(showAlert({ message: DEFAULT_ERROR_MESSAGE }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
